export enum RecruiterStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  BLOCKED = 'blocked',
  REJECTED = 'rejected',
  WAITING = 'waiting',
  UNKNOWN = 'unknown',
}
